// GENERATED by scripts/build-icons.mjs from icons/arrow-up-right.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ArrowUpRight = createIcon('arrow-up-right', [
  ['path', { d: "M7 7h10v10" }],
  ['path', { d: "M7 17 17 7" }],
])
